<template>
    <div class="modal fade show custom-modal" id="discardQuoteModal" :class="{'modal-show':showDiscardQuote}">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-head">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal()" id="discard-modal-cross-close"> 
                        <img src="@/assets/images/popup-close.png" alt="X" />
                    </button>
                </div>
                <div class="modal-body text-center position-relative mt-2">
                    <div class="col-12 text-center mt-5 mb-5">
                        <p class="mt-2">Do you really want to discard?<br> <span v-if="motorQuoteApplicability" class="font-weight-bold">Quote-ID: {{quoteId}}</span>
                        </p>
                    </div>
                    <div class="bgc-button-grp text-center">
                        <button type="button" class="bgc-btn-primary" @click="removeQuote();closeModal()" data-dismiss="modal" id="close-modal-yes">Yes</button>
                        <button type="button" class="bgc-btn-secondary ml-3" data-dismiss="modal" @click="closeModal()" id="close-modal-no">No</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { reactive } from '@vue/composition-api';
export default {
     name: 'DiscardQuoteModal',
     props: ['quoteId','showDiscardQuote','motorQuoteApplicability'],
     components:{

     },
     setup(props,context){
        let state = reactive({
        });
        //methods
        function removeQuote(){
            context.parent.removeQuote();
        }
        // **Closes the Discard Confirmation modal **
        function closeModal() {
            context.parent.closeDiscardQuoteModal();
        }
        //return
        return{
            removeQuote,
            closeModal
        }
    }
};
</script>
<style scoped>
.custom-modal {
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0, 0, 0, 0.4);
    transform: scale(0);
}
.modal-show {
    display: block;
    transform: scaleY(0) scaleX(0);
    animation: unfoldIn 0.25s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
}
.modal-head{
    -ms-flex-negative:0;
    flex-shrink:0;
    margin: 9px 5px 1px 5px;
    justify-content:space-between;
}
.modal-body{
    overflow-y: auto;
}
</style>
